<div class="inner-page-bg-right">
  <section class="bx"> <h5 data-aos="fade-down" class="heading1_3">Sell Personalised Digital Gift Cards</h5></section> 
  <section
  class="container bx1"
  id="gc_form_main_section"
>
  <h5 data-aos="fade-down" class="heading1_3 styled-heading">
    Your Customers will Love it!
  </h5>
</section>

<section class="container live_tour_heading">
  <h2 class="heading1_4">Take a Live Tour - See it in Action!</h2>
  <div class="arrow-button arrow">
      <a class="arrow" href="https://scanfluence.com/digital-gift-cards-test.html" target="_blank">
      <span>Explore</span>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-arrow-up"
      >
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
      </svg>
    </a>
  </div>
</section>

  <section class="container live_tour_heading bx3">
    <h4 class="heading1_3 styled-heading" >Gift card - Sample screenshot / preview</h4>
  </section>
  <div class="gift-card-form-main-sections cust_container">
          <section class="gift_card_preview-section bx4">
      <img
        src="../../../assets/images/giftcard_Screenshot.png"
        alt="Gift Card Preview"   class="bx6"/>
  </section>
</div>
    <section class="container heading1_3 bx5 styled-heading">
      <h2>Start Selling Gift Cards Online – It’s Easy to Integrate!</h2>
    </section>

      <section class="container live_tour_heading heading1_4 bx5 bx7">

      <h3> Step 1:</h3>
        <h3>  Make sure you have an active Shopify or WooCommerce store.</h3>
        
       <h3> Step 2:</h3>
       <h3> Install the Scanfluence Gift Card App from your store’s app marketplace.</h3>
        
      <h3>  Step 3:</h3>
      <h3> Log in to your Scanfluence Profile Page (top right corner), generate your Access Key and Private Key, and enter them into the app settings on your store.</h3>
        
      <h2>  That’s it!</h2>
      <h2>  You're ready to start selling gift cards!</h2>
        
      <h5>For support, email us at 
        <a href="mailto:consult@scanfluence.com">consult@scanfluence.com</a>
      </h5>
          </section>

 
 </div>
